module.exports = __webpack_public_path__ + "img/puroak.icon.logSplitter.asset.856ba444.svg";